<template>
  <!-- 模板部分无变化 -->
  <el-dialog
    title="修改隐患排查信息 "
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form size="small" :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入隐患排查信息名称" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="inspection_type_id">
          <el-select 
            v-model="form.inspection_type_id" 
            placeholder="请选择类型"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="dept in typeList"
              :key="dept.inspection_type_id"
              :label="dept.name"
              :value="dept.inspection_type_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属组织" prop="ma_organization_id">
          <el-select 
            v-model="form.ma_organization_id" 
            placeholder="请选择所属组织"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="dept in organizationList"
              :key="dept.ma_organization_id"
              :label="dept.name"
              :value="dept.ma_organization_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检查项" prop="ma_check_item_id">
          <el-select 
            v-model="form.ma_check_item_id" 
            placeholder="请选择检查项"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="item in inspectionItemOptions"
              :key="item.ma_check_item_id"
              :label="item.name"
              :value="item.ma_check_item_id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="已检车辆" prop="inspected_vehicles">
          <el-input-number 
            v-model="form.inspected_vehicles" 
            placeholder="请输入已检车辆数量" 
            class="max-w460"
            :min="0"  
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="正常车辆" prop="normal_vehicles">
          <el-input-number 
            v-model="form.normal_vehicles" 
            placeholder="请输入正常车辆数量" 
            class="max-w460"
            :min="0"
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="异常车辆" prop="abnormal_vehicles">
          <el-input-number 
            v-model="form.abnormal_vehicles" 
            placeholder="请输入异常车辆数量" 
            class="max-w460"
            :min="0"
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="整改完成车辆" prop="rectified_vehicles">
          <el-input-number 
            v-model="form.rectified_vehicles" 
            placeholder="请输入整改完成车辆数量" 
            class="max-w460"
            :min="0"
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="有效时间" prop="valid_time">
          <el-date-picker 
            v-model="form.valid_time" 
            type="date" 
            placeholder="请选择有效时间" 
            value-format="yyyy-MM-dd"
            class="max-w460"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="检查人" prop="inspect_uid">
          <el-select
            v-model="form.inspect_uid"
            multiple
            placeholder="请选检查人"
            clearable
          >
            <el-option
              v-for="item in peopleList"
              :key="item.ma_yg_id"
              :label="`${item.name}(${item.depart_name || '无部门'})`"
              :value="String(item.ma_yg_id)"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>

        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    </div>
  </el-dialog>
</template>

<script>
import Ma_hzd_inv_infoApi from '@/api/ma_hzd_inv_info.js';
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: { Upload, draggable, Uediter },
  data() {
    return {
      peopleList: [],
      isupload: false,
      isImg: false,
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      form: {
        name: '',
        inspection_type_id: '',
        ma_organization_id: '',
        ma_check_item_id: '',
        inspected_vehicles: 0,
        normal_vehicles: 0,
        abnormal_vehicles: 0,
        rectified_vehicles: 0,
        valid_time: '',
        inspect_uid: [],
        sort: 50,
        code: 'custom',
        image: [],
        intro: "",
        bannar: []
      },
      inspectionItemOptions: [],
      loadingInspectionItems: false,
      loading: false,
      organizationList: [],
      typeList: [],
      rules: {
        name: [
          { required: true, message: '请输入隐患排查信息名称', trigger: 'blur' }
        ],
        ma_check_item_id: [  
          { required: true, message: '请选择检查项', trigger: 'change' }
        ],
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.loadBaseData().then(() => {
      this.dialogVisible = this.open_add;
      if (this.ma_hzd_inv_info_id) {
        this.getDetail();
      }
    });
  },
  props: ["open_add", "ma_hzd_inv_info_id"],
  methods: {
    async loadBaseData() {
      try {
        await Promise.all([
          this.loadPeopleList(),
          this.loadOrganization(),
          this.loadInspectionType(),
          this.loadInspectionItems()
        ]);
      } catch (error) {
        console.error('加载基础数据失败:', error);
      }
    },

    async loadPeopleList() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_yg',
          action: 'getList',
        });
        this.peopleList = response.code === 1 && response.data.list.data ? response.data.list.data : [];
      } catch (error) {
        this.peopleList = [];
        console.error('加载人员列表失败:', error);
      }
    },
    async loadOrganization() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_organization',
          action: 'getList',
          page: 1,
          list_rows: 1000
        });
        this.organizationList = response.code === 1 && response.data.list ? response.data.list.data : [];
      } catch (error) {
        this.organizationList = [];
        console.error('加载组织列表失败:', error);
      }
    },
    async loadInspectionType() {
      try {
        const response = await AfuncApi.call({
          model: 'inspection_type',
          action: 'getList',
          page: 1,
          list_rows: 1000
        });
        this.typeList = response.code === 1 && response.data.list.data ? response.data.list.data : [];
      } catch (error) {
        this.typeList = [];
        console.error('加载检查类型失败:', error);
      }
    },
    async loadInspectionItems() {
      this.loadingInspectionItems = true;
      try {
        const response = await AfuncApi.call({
          model: 'ma_check_item',
          action: 'getList',
          p_id: 0
        });
        if (response && response.code === 1) {
          this.inspectionItemOptions = response.data.list.data || [];
        } else {
          this.$message.warning('加载检查项失败：' + (response.msg || '接口无响应'));
          this.inspectionItemOptions = [];
        }
      } catch (error) {
        this.inspectionItemOptions = [];
        console.error('加载检查项异常:', error);
        this.$message.error('加载检查项失败，请刷新重试');
      } finally {
        this.loadingInspectionItems = false;
      }
    },

    resetForm() {
      this.form = {
        name: '',
        inspection_type_id: '',
        ma_organization_id: '',
        ma_check_item_id: '',
        inspected_vehicles: 0,
        normal_vehicles: 0,
        abnormal_vehicles: 0,
        rectified_vehicles: 0,
        valid_time: '',
        inspect_uid: [],
        sort: 50,
        code: 'custom',
        image: [],
        intro: "",
        bannar: []
      };
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },
    chooseCategory() {
      this.iscategorya = true;
    },
    openUpload(e) {
      this.isupload = true;
    },
    returnImgsFunc(e) {
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    dialogFormVisible(result) {
      this.resetForm();
      this.$emit("close", {});
    },
    cancelFunc() {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    getDetail() {
      let self = this;
      this.loading = true;
      Ma_hzd_inv_infoApi.detail({ ma_hzd_inv_info_id: self.ma_hzd_inv_info_id }, true).then(res => {
        if (res && res.data) {
          const formData = res.data;
          self.form = {
            ...formData,
            inspect_uid: Array.isArray(formData.inspect_uid)
              ? formData.inspect_uid.map(id => String(id))
              : (formData.inspect_uid ? [String(formData.inspect_uid)] : []),
            inspected_vehicles: Number(formData.inspected_vehicles) || 0,
            normal_vehicles: Number(formData.normal_vehicles) || 0,
            abnormal_vehicles: Number(formData.abnormal_vehicles) || 0,
            rectified_vehicles: Number(formData.rectified_vehicles) || 0,
            sort: Number(formData.sort) || 50,
            bannar: formData.bannar || [],
            image: formData.image || [],
            ma_check_item_id: formData.ma_check_item_id || '',
            serial_number: undefined
          };

          self.ueditor.text = self.form.intro || '';
          self.isImg = !!self.form.image;
        }
        self.loading = false;
      }).catch(error => {
        self.loading = false;
        console.error('获取详情失败:', error);
      });
    },
    onSubmit() {
      let self = this;
      let form = { ...self.form };
      form.ma_hzd_inv_info_id = self.ma_hzd_inv_info_id;

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Ma_hzd_inv_infoApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg || '修改成功',
                type: 'success'
              });
              self.dialogFormVisible("success");
            })
            .catch(error => {
              self.loading = false;
              console.error('修改失败:', error);
              self.$message.error('修改失败，请稍后重试');
            });
        }
      });
    },
    openProductUpload(code) {
      this.isProductUpload = true;
      this.code = code;
    },
    returnProductImgsFunc(e) {
      if (!e || e.length === 0) return;

      const imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
      let hasValidImage = false;
      for (const element of e) {
        const ext = element.file_path.split(".").pop().toLowerCase();
        if (imgExpt.includes(ext)) {
          hasValidImage = true;
          break;
        }
      }
      if (!hasValidImage) {
        this.$message.error("图片类型有误,请选择正确的图片格式(bmp,jpg,jpeg,png,gif)");
        return false;
      }
      if (this.code === 'album') {
        this.form.image = this.form.image.concat(e);
      } else {
        this.form.bannar = this.form.bannar.concat(e);
      }
      this.isProductUpload = false;
    },
    deleteImg(index, code) {
      if (code === 'album') {
        this.form.image.splice(index, 1);
      } else if (code === 'bannar') {
        this.form.bannar.splice(index, 1);
      }
    },
  }
};
</script>

<style scoped>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.max-w460 {
  width: 100%;
  max-width: 460px;
}

.pb50 {
  padding-bottom: 50px;
}

.common-button-wrapper {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.common-button-wrapper .el-button {
  margin: 0 10px;
}

.el-cascader {
  width: 100%;
}

@media (max-width: 768px) {
  .max-w460 {
    max-width: 100%;
  }
  .el-dialog {
    width: 90% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/plus/ma_hzd_inv_info/index/part/edit.vue